import { createAction } from '@reduxjs/toolkit';

/**
 * Global store reset action for user impersonation scenarios
 * This action should be handled by all slices to reset their state to initial values
 */
export const resetStore = createAction('store/RESET');

/**
 * Comprehensive store reset action type
 * Legacy support for existing RESET_STORE dispatches
 */
export const RESET_STORE = 'RESET_STORE';